import { createFileRoute } from "@tanstack/react-router";
import ProblemasEnMiTienda from "@/pages/ProblemasEnMiTienda";

// Nota SEO: title/description/og:*/twitter:*/canonical los emite <SEO />
// (Helmet, también en SSR) dentro de SolutionProgramPage.
export const Route = createFileRoute("/en/store-problems")({
  component: ProblemasEnMiTienda,
});
